import LegalPage from "@/components/LegalPage";

const sections = [
  {
    h: "About this website",
    paras: [
      "This website is operated by KC Consultancy, the trading name of Kathleen Cullen Care Limited, a specialist Youth Justice consultancy working across England and Wales. By using this website you accept these Terms of Use. If you do not accept them, please do not use this website.",
    ],
  },
  {
    h: "Information, not advice",
    paras: [
      "The content of this website is provided for general information only. It does not constitute professional advice, and it should not be relied upon as such.",
      "Professional advice and consultancy services are provided only under a written agreement between KC Consultancy and the client organisation.",
    ],
  },
  {
    h: "Intellectual property",
    paras: [
      "All content on this website — including text, design and branding — belongs to KC Consultancy unless otherwise stated. You may view and print pages for your organisation's internal use.",
      "You may not reproduce, republish or commercially exploit any content without our prior written consent.",
    ],
  },
  {
    h: "Accuracy of information",
    paras: [
      "We take reasonable care to keep the information on this website accurate and up to date, but we make no representations or warranties of any kind, and we may change the content at any time without notice.",
    ],
  },
  {
    h: "External links",
    paras: [
      "Where this website links to third-party websites, those links are provided for convenience. We have no control over, and accept no responsibility for, the content of external websites.",
    ],
  },
  {
    h: "Liability",
    paras: [
      "Nothing in these terms excludes or limits liability that cannot be excluded or limited by law.",
      "Subject to that, KC Consultancy will not be liable for any loss or damage arising from the use of, or inability to use, this website or reliance on its content.",
    ],
  },
  {
    h: "Privacy and data",
    paras: [
      "Any personal information you provide through this website is handled in accordance with our Privacy Policy and Cookie Policy.",
    ],
  },
  {
    h: "Governing law",
    paras: [
      "These Terms of Use are governed by the laws of England and Wales, and the courts of England and Wales have exclusive jurisdiction over any dispute arising from them.",
    ],
  },
];

export default function Terms() {
  return (
    <LegalPage
      title="Terms of Use"
      updated="July 2026"
      sections={sections}
      testid="terms-page"
    />
  );
}
